import * as React from "react";
import { Link, NavLink } from "react-router-dom";

import { RiMenuLine, RiLogoutBoxRLine } from "react-icons/ri";

import { Links, Bottom_Links, ProfileFirstConnect } from "./Helpers";

import Button from "../Button";

import { useConnectedUser } from "../../Context/ConnectedUserContext";

import MenuExpand from "./../../Images/menu_expand.png";

import "./Sidebar.scss";

const Sidebar = (props) => {
  const { isExpandedBar, onClickExpand } = props;

  const { logout, isFirstTimeConnect } = useConnectedUser();

  return (
    <div className={`sideBar ${isExpandedBar ? "" : "sidebar-small"}`}>
      <div className="wrap-expand-icon">
        <Button view="none" isIconButton onClick={onClickExpand}>
          {isExpandedBar ? (
            <img
              src={MenuExpand}
              alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
            />
          ) : (
            <RiMenuLine />
          )}
        </Button>
      </div>
      {isFirstTimeConnect ? (
        <ul className="links-app">
          {ProfileFirstConnect.map(({ path, name, Icon }, i) => {
            return (
              <div key={`link-${i}`}>
                <li className="list-link">
                  <NavLink to={path} className="link-sidebar">
                    <Icon className="icon-link" />
                    <span className="name-link">{name}</span>
                  </NavLink>
                </li>
              </div>
            );
          })}
        </ul>
      ) : (
        <>
          <ul className="links-app">
            {Links.map(({ path, name, Icon, disbled }, i) => {
              return (
                <div key={`link-${i}`}>
                  <li className="list-link" title={name}>
                    {disbled ? (
                      <div className="link-sidebar disabled">
                        <Icon className="icon-link" />
                        <span className="name-link">{name}</span>
                      </div>
                    ) : (
                      <NavLink to={path} className="link-sidebar">
                        <Icon className="icon-link" />
                        <span className="name-link">{name}</span>
                      </NavLink>
                    )}
                  </li>
                </div>
              );
            })}
          </ul>
          <div className="wrap-logout-icon">
            {Bottom_Links.map(({ path, name, Icon, disbled }, i) => {
              return (
                <div key={`link-${i}`}>
                  <div className="list-link" title={name}>
                    {disbled ? (
                      <div className="link-sidebar disabled">
                        <Icon className="icon-link" />
                        <span className="name-link">{name}</span>
                      </div>
                    ) : (
                      <NavLink to={path} className="link-sidebar">
                        <Icon className="icon-link" />
                        <span className="name-link">{name}</span>
                      </NavLink>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      <div className="wrap-logout-icon">
        <Link className="link-account" onClick={logout}>
          <RiLogoutBoxRLine />
          <span className="name-link">Se déconnecter</span>
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
